<template>
  <div>
    <div>
      <v-btn v-if="$vuetify.breakpoint.mobile" outlined color="primary" @click="addContact" small>Add contact</v-btn>
    </div>
    <v-data-table class="px-4" calculate-widths disable-filtering disable-pagination disable-sort hide-default-footer
                  fixed-header height="calc(100vh - 204px)"
                  :items="contacts" item-key="id" no-data-text="No contacts"
                  :headers="[{text:'',value:'add',width:'5%',align:'center',cellClass:'pa-0'},
                      { text: 'Name', value: 'name', width:'35%'},
                      { text: 'Title', value: 'title' ,width:'20%'},
                      { text: 'Email', value: 'email' ,width:'25%'},
                      { text: 'Phone', value: 'phone' ,width:'15%'}]">
      <template v-slot:header.add v-if="!$vuetify.breakpoint.mobile">
        <v-btn fab color="primary" x-small @click="addContact"><v-icon small>mdi-plus</v-icon></v-btn>
      </template>
      <template v-slot:item.add="{index}">
        <v-btn class="mt-n5" icon @click.stop="deleteContact(index)" x-small><v-icon>mdi-delete</v-icon></v-btn>
      </template>
      <template v-slot:item.name="{item}">
        <v-text-field dense outlined v-model="item.name" class="text-caption mt-2" :rules="[fieldRules.required,fieldRules.maxLength(100)]"/>
      </template>
      <template v-slot:item.title="{item}">
        <v-text-field dense outlined v-model="item.title" class="text-caption mt-2" :rules="[fieldRules.maxLength(50)]"/>
      </template>
      <template v-slot:item.email="{item}">
        <v-text-field dense outlined v-model="item.email" class="text-caption mt-2" :rules="[fieldRules.email,fieldRules.maxLength(50)]"/>
      </template>
      <template v-slot:item.phone="{item}">
        <v-text-field dense outlined v-model="item.phone" class="text-caption mt-2" :rules="[fieldRules.phone,fieldRules.maxLength(20)]"/>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "Contacts",
  props: {
    contacts: {type:Array,required:true}
  },
  methods: {
    addContact() {
      this.contacts.push({name:'',title:'',email:'',phone:''});
      this.$emit('validate');
    },
    deleteContact(index) {
      this.contacts.splice(index, 1);
    }
  }
}
</script>